import * as React from 'react';
import {ApolloProvider} from 'react-apollo';
import ReactDOM from 'react-dom';
import {Provider} from 'react-redux';
// @ts-expect-error
import ReactTooltip from 'react-tooltip';

import {ApolloProvider as ReactHooksApolloProvider} from '@apollo/react-hooks';

import {nutApolloClient} from '../apollo-client';
import {store} from '../store';
import {PlanComparisonRoot} from '../ui/setup/billing/plan-comparison-root';
import type {SuiteType} from '../ui/setup/billing/plan-comparison-root';

import 'less/auth.less';

const mountDiv = document.querySelector('#plan-comparison-mount');

if (mountDiv) {
    ReactDOM.render(
        <Provider store={store}>
            <ApolloProvider client={nutApolloClient}>
                <ReactHooksApolloProvider client={nutApolloClient}>
                    {/* @ts-expect-error */}
                    <PlanComparisonRoot suiteType={getSuiteType(mountDiv.dataset.suiteType)} />
                </ReactHooksApolloProvider>
            </ApolloProvider>
        </Provider>,
        mountDiv
    );

    const tooltipMount = document.createElement('div');
    if (document.body) {
        document.body.appendChild(tooltipMount);
        ReactDOM.render(
            <ReactTooltip
                delayShow={300}
                className='react-tooltip'
                effect='solid'
                multiline={true}
            />,
            tooltipMount
        );
    }
}

function getSuiteType(mountData: string): SuiteType {
    if (mountData === 'engagement') {
        return 'engagement';
    }
    if (mountData === 'marketing') {
        return 'marketing';
    }

    return 'sales';
}
